import { useState } from "react";
import { useHistory } from "react-router-dom";
import useTranslations from "../../../core/i18n/useTranslations";
import { AdministratorDetails } from "../../../core/api/administrators/types";
import { impersonate } from "../../../core/api/administrators/administrators";
import useUser from "../../../core/user/useUser";
import { notifyApiErrors } from "../../../core/helpers/helpers";
import PrimeModal from "../../../ui-lib/components/PrimeModal/PrimeModal";

export const IMPERSONATE_LOCATION = "impersonate-location";

export const ImpersonateModal = ({
  isOpen,
  adminData,
  onClose,
}: {
  isOpen: boolean;
  adminData: AdministratorDetails;
  onClose: () => void;
}) => {
  const t = useTranslations();
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const user = useUser();

  const impersonateMe = async () => {
    try {
      setIsLoading(true);

      const result = await impersonate(adminData.id, user.authenticatedRequest);

      user.impersonatedFrom = user.data?.name;

      await user.logIn({
        token: result.data.access_token,
        refreshToken: result.data.refresh_token,
        expiresIn: result.data.expires_in,
      });
      localStorage.setItem(IMPERSONATE_LOCATION, history.location.pathname);
      history.replace("/adminportal");
    } catch (error: any) {
      notifyApiErrors(error.response?.data?.errors);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PrimeModal
      withFooter
      withHeader
      header={t("Administrator:impersonate_modal_title").replace(
        "{0}",
        adminData.username,
      )}
      isOpen={isOpen}
      onClose={onClose}
      fixedWidth="576px"
      loading={isLoading}
      submitBtn={{
        text: t("Administrator:yes_continue"),
        onClick: impersonateMe,
      }}
      cancelBtn={{
        text: t("Common:cancel"),
        onClick: onClose,
      }}
    >
      <p>{t("Administrator:impersonate_modal_description")}</p>
    </PrimeModal>
  );
};
